// extracted by mini-css-extract-plugin
module.exports = {"truncate1":"mf-Gi","truncate3":"mf-Gj","truncate4":"mf-Gk","truncate6":"mf-Gl"};